import { api } from "../api";

export const defaultQueryFn = async ({ queryKey }) => {
  return api
    .url(queryKey[0])
    .get()
    .json()
    .then((res) => {
      return res;
    })
    .catch((e) => {
      console.log("caught error", e);
      throw e;
    });
};
